import { AddCommandBarStateValue } from '../command-bar-context.js';

import type { CommandBarProviderConfig, CommandBarProviderProps } from '../command-bar-types.js';

/**
 * Component to register a command bar provider.
 * The provider component will be rendered inside the command bar when it's open.
 */
export function AddCommandBarProvider<TProps extends CommandBarProviderProps>({
	provider,
}: {
	provider: CommandBarProviderConfig<TProps>;
}) {
	return <AddCommandBarStateValue okey='providers' value={provider as unknown as CommandBarProviderConfig} />;
}
